import * as React from 'react';
import {PluginTemplates} from "../../../../utils/PluginTemplates";
import {lazyInject} from "@athena-portal/core";
import {Policy, ProductsEnum, Quote} from "@ferry/journey-services";
import {Footer} from "@ferry/portal-core";
import FalconHeader from "../../../../components/navigation/FalconHeader";
import {authorize, Overlay} from "@athena-portal/components";
import {YourQuotesPanel} from "./YourQuotesPanel";
import {Types} from "../../../../Types";
import type {ICustomerPortalService} from "../../../../services/ICustomerPortalService";

interface IState {
    quotes?: Quote[];
    policies?: Policy[];
}

@authorize
export class AnnualQuotesPage extends React.Component<{}, IState> {

    private pluginTemplates = new PluginTemplates();

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: Readonly<{}>) {
        super(props);
        this.state = {}
    }

    public componentDidMount(): void {
        this.pluginTemplates.setPageTitle("Your annual quote(s)");
        this.customerPortalService.getQuotes().subscribe((quotes: Quote[]) => this.setState({
            quotes: this.getQuotesByProduct(quotes, ProductsEnum.WOLF_MOTOR)}));
        this.customerPortalService.getPolicies().subscribe((policies: Policy[]) => {
            this.setState({policies});
        });
    }

    public render() {
        const {policies, quotes} = this.state;

        if (quotes && policies) {
            return (
                <React.Fragment>
                    <FalconHeader/>
                    <YourQuotesPanel
                        quotes={quotes}
                        isActivePoliciesPresent={policies.length > 0}
                        policies={policies}/>
                    <Footer/>
                </React.Fragment>
            )
        } else {
            return <Overlay show={true}/>
        }
    }

    private getQuotesByProduct(quotes: Quote[], product: string): Quote[] {
        return quotes?.filter((quote) => quote?.product === product);
    }
}
